import UserService from 'Services/user';

export default {
	name: 'Confirmation',
	created() {
		if (this.$store.state.user.isConfirmed === true) {
			this.$router.push('/');
			return;
		}
		this.isLoading = true;
		UserService.getAccountInfo()
			.then(response => {
				this.credential.email = response.data.nick;
				this.credential.firstname = response.data.firstname;
				this.credential.lastname = response.data.lastname;
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	data() {
		return {
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			isLoading: false,
			isConfirmed: false,
			credential: {
				email: '',
				firstname: '',
				lastname: ''
			}
		};
	},
	methods: {
		confirm() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isLoading = true;
					UserService.requestConfirm(this.credential)
						.then(response => {
							this.isConfirmed = true;
						})
						.catch(error => {
							this.errors.add({
								field: 'apierror',
								msg: error.response.data.Message
							});
						})
						.finally(() => {
							this.isLoading = false;
						});
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/confirmation/script.js